import { useEffect, useState } from "react"
import React from "react"
import {
	TSelectedTableRowId,
	TTableHeadCell,
} from "components/ProjectSpecificComponents/Interfaces/TableInterface"
import { Tr } from "./StyledComponents/TableStyleComp"

interface Props {
	row: any
	head: any[]
	selectedRowId?: TSelectedTableRowId
	editTableCell: EditTableCellCreateFn
	onFocus?: (e: any) => void
	onBlur?: (e: any) => void
}

export const EditTableRow = ({
	row,
	head,
	selectedRowId,
	editTableCell,
	onFocus = () => {},
	onBlur = () => {},
}: Props) => {
	const stavoklis: number = row?.stavoklis ?? 0

	/**
	 * The logic here is that `setFocused` is called upon every <tr />
	 * onfocus and onblur event, however, a `useEffect` will make it so that
	 * if they are both fired consecutively, only one is applied onto
	 * `onFocus` or `onBlur` from props.
	 *
	 * This allows for uninterrupted switching from one cell input field
	 * to the same row's another cell input field.
	 */
	const [focused, setFocused] = useState(false)
	const [EventInfo] = useState<{
		currentEvent: any
		/**
		 * Keeps around 2 most recent events.
		 */
		registeredEvents: any[]
	}>({
		currentEvent: null,
		// The first 2 "events" are / must be already given.
		registeredEvents: [null, null],
	})

	useEffect(() => {
		let timeoutId = setTimeout(() => {
			if (!EventInfo.currentEvent) return

			// Keeps recent 2 event history going
			EventInfo.registeredEvents.push(EventInfo.currentEvent)
			EventInfo.registeredEvents.shift()

			// Fires onfocus or onblur, but only if last event was not
			// of that same type
			let lastEventType = EventInfo.registeredEvents[0]?.type
			if (focused && lastEventType != "focus") onFocus(EventInfo.currentEvent)
			if (!focused && lastEventType != "blur") onBlur(EventInfo.currentEvent)
		}, 0)

		return () => clearTimeout(timeoutId)
	}, [focused])

	const _updateFocus = (e: any) => {
		EventInfo.currentEvent = e
		setFocused(e.type == "focus" ? true : false)
	}

	return (
		<Tr
			className={`${stavoklis > 0 && `rowStatus_${stavoklis}`}`}
			style={{
				borderLeft: selectedRowId === row?.id ? "8px solid #008496" : "initial",
				backgroundColor: selectedRowId === row?.id ? "#f2f2f2" : "initial",
			}}
			onFocus={_updateFocus}
			onBlur={_updateFocus}
		>
			{head.map((cellHead) => editTableCell(row, cellHead, selectedRowId))}
		</Tr>
	)
}

export default EditTableRow

export type EditTableCellCreateFn = (
	row: any,
	cellHead: TTableHeadCell,
	rowId?: TSelectedTableRowId
) => React.ReactNode
